import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../../shared/services/data.service';
import { TabsService } from '../../shared/components/tabs/tabs.service';
import { StorageService } from '../../shared/services/storage.service';
import { Observable, tap } from 'rxjs';
import { Result } from '../../shared/model/response.model';
import { IMPORT_API } from '../../shared/import/import-api.constants';

@Injectable({
  providedIn: 'root'
})
export class CommonImportDocumentService {
  constructor(public dataService:DataService,
    private tabsService: TabsService,
    private router: Router,
    public storageService: StorageService) { }

  public importPartTemplate (data:any):Observable<Result>{
    return this.dataService.post(IMPORT_API.parts.importPartTemplate, data).pipe<Result>(tap((response:any)=>{
      return response;
    }))
  }

  public importPart (data:any):Observable<Result>{
    return this.dataService.post(IMPORT_API.parts.importPart, data).pipe<Result>(tap((response:any)=>{
      return response;
    }))
  }
  public importInventoryTemplate (data:any):Observable<Result>{
    return this.dataService.post(IMPORT_API.parts.importInventoryTemplate, data).pipe<Result>(tap((response:any)=>{
      return response;
    }))
  }
  public importInventory (data:any):Observable<Result>{
    return this.dataService.post(IMPORT_API.parts.importInventory, data).pipe<Result>(tap((response:any)=>{
      return response;
    }))
  }
  public importConsignmentTemplate (data:any):Observable<Result>{
    return this.dataService.post(IMPORT_API.parts.importConsignmentTemplate, data).pipe<Result>(tap((response:any)=>{
      return response;
    }))
  }
  public importConsignment (data:any):Observable<Result>{
    return this.dataService.post(IMPORT_API.parts.importConsignment, data).pipe<Result>(tap((response:any)=>{
      return response;
    }))
  }
  public importOemExcessTemplate (data:any):Observable<Result>{
    return this.dataService.post(IMPORT_API.parts.importOEMExcessTemplate, data).pipe<Result>(tap((response:any)=>{
      return response;
    }))
  }
  public importOemExcess (data:any):Observable<Result>{
    return this.dataService.post(IMPORT_API.parts.importOEMExcess, data).pipe<Result>(tap((response:any)=>{
      return response;
    }))
  }
  public importVendorPartTemplate (data:any):Observable<Result>{
    return this.dataService.post(IMPORT_API.parts.importVendorPartTemplate, data).pipe<Result>(tap((response:any)=>{
      return response;
    }))
  }
  public importVendorPart (data:any):Observable<Result>{
    return this.dataService.post(IMPORT_API.parts.importVendorPart, data).pipe<Result>(tap((response:any)=>{
      return response;
    }))
  }
}
